import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  CanActivateChildFn,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../providers/auth/auth.service';

function isAuthorized(route: ActivatedRouteSnapshot, url: string): Observable<boolean | UrlTree> {
  const authService = inject(AuthService);
  const router = inject(Router);

  const check$ = url.includes('auth')
    ? authService.checkSession(true)
    : authService.checkSession();

  return check$.pipe(
    map((isSessionValid: boolean) => {
      if (!isSessionValid) {
        return router.createUrlTree(['/auth/login']);
      }
      const expectedRoles = route.data['roles'] as string[];
      if (expectedRoles && expectedRoles.length > 0) {
        const userJson = localStorage.getItem('currentUser');
        if (!userJson) {
          return router.createUrlTree(['/unauthorized']);
        }

        const user = JSON.parse(userJson);
        const userRoles: string[] = user.roles || [];

        const hasRole = expectedRoles.some(role => userRoles.includes(role));
        if (!hasRole) {
          return router.createUrlTree(['/unauthorized']);
        }
      }

      return true;
    }),
    catchError(() => {
      return of(router.createUrlTree(['/auth/login']));
    })
  );
}

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean | UrlTree> => {
  return isAuthorized(route, state.url);
};

export const authGuardChild: CanActivateChildFn = (
  childRoute: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean | UrlTree> => {
  return isAuthorized(childRoute, state.url);
};
